import React from 'react';
import MuiIconButton, { type IconButtonProps as MuiIconButtonProps } from '@mui/material/IconButton';

import Icon, { type IconName, iconNames } from '@/components/icons';

type IconButtonProps = MuiIconButtonProps & {
  iconName: IconName;
  ariaLabel?: string;
};

const IconButton = ({ ariaLabel, className, edge, iconName, onClick, name }: IconButtonProps) => (
  <MuiIconButton edge={edge} aria-label={ariaLabel} {...{ onClick, className, name }}>
    <Icon name={iconNames[iconName]} />
  </MuiIconButton>
);

export { IconButton };
